<template>
  <div class="sidebar sidebar-light sidebar-main sidebar-fixed sidebar-expand-md sidebar-subtracted">
    <div class="sidebar-content">
      <div class="card card-sidebar-mobile">
        <div class="card-body p-0" v-if="authStore.isAdmin">
          <ul class="nav nav-sidebar">
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.users.index' }" class="nav-link">
                <clients-icon/>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.promo.index' }" class="nav-link">
                <ppk-icon/>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.api-key.index' }" class="nav-link">
                <unlock-icon/>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.referrals.index' }" class="nav-link">
                <database-icon/>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.feature-flags.index' }" class="nav-link">
                <expense-icon/>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.validation-logs.index' }" class="nav-link">
                <info-icon/>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.export-logs.index' }" class="nav-link">
                <drawer-icon/>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.features.index' }" class="nav-link">
                <piggy-bank-icon/>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.voting-event.index' }" class="nav-link">
                <calendar-icon/>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.new-users-statistics.index' }" class="nav-link">
                <increase-icon/>
              </router-link>
            </li>
            <li class="nav-item nav-item-submenu">
              <router-link :to="{ name: 'admin.okredo-api.index' }" class="nav-link">
                <plug-icon/>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import ClientsIcon from '@/components/icons/clients';
  import ExpenseIcon from '@/components/icons/expense';
  import PpkIcon from '@/components/icons/ppk';
  import UnlockIcon from '@/components/icons/unlock';
  import DatabaseIcon from '@/components/icons/database';
  import PiggyBankIcon from '@/components/icons/piggy-bank';
  import { useSidebarStore } from '@/stores/sidebar';
  import { useAuthStore } from '@/stores/auth';
  import { computed, watch } from 'vue';
  import InfoIcon from '@/components/icons/info.vue';
  import CalendarIcon from '@/components/icons/calendar.vue';
  import IncreaseIcon from '@/components/icons/increase-icon.vue';
  import PlugIcon from '@/components/icons/plug.vue';
  import DrawerIcon from '@/components/icons/drawer.vue';

  const emit = defineEmits(['subOpen']);

  const props = defineProps({
    state: {
      required: true,
      type: Boolean,
    },
  });

  const sidebarStore = useSidebarStore();
  const authStore = useAuthStore();

  const mobileOpen = computed(() => sidebarStore.mobileOpen);

  watch(mobileOpen, () => {
    if (props.state) {
      sidebarStore.updateMobileOpen(true);
      emit('subOpen', false);
    }
  });
</script>
